export const DEBUG =
  (typeof process !== 'undefined' &&
    process &&
    process.env &&
    String(process.env.NODE_ENV || '').toLowerCase() !== 'production') ||
  (typeof window !== 'undefined' &&
    window &&
    window.location &&
    String(window.location.hostname || '').includes('localhost'));

export const debugLog = (...args) => {
  if (DEBUG) console.log(...args);
};

export const debugWarn = (...args) => {
  if (DEBUG) console.warn(...args);
};


